import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/close-circle.svg'
import _imports_1 from '../assets/profile.svg'


const _withScopeId = n => (_pushScopeId("data-v-2e40ad5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-table" }
const _hoisted_2 = { class: "icon-column" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "heading-column" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Settings")
], -1))
const _hoisted_6 = { class: "icon-column" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center top-spacing" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "profile-icon",
    src: _imports_1
  }),
  /*#__PURE__*/_createElementVNode("p", null, "Edit your user profile and security settings")
], -1))
const _hoisted_8 = {
  key: 0,
  class: "center-div"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Your Email: ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://docs.google.com/forms/d/e/1FAIpQLSfOkqKunFuJRsI8CqNlRKKNSrbBK56zWB2gMz0H9IVgP0hy0w/viewform"
}, " Send feedback or report an issue with MiROS ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _createElementVNode("tr", null, [
        _createElementVNode("td", _hoisted_2, [
          _createElementVNode("button", {
            class: "icon-button margin",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToProjectsPage()))
          }, _hoisted_4)
        ]),
        _hoisted_5,
        _createElementVNode("td", _hoisted_6, [
          _createElementVNode("button", {
            class: "rectangle-button red-button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doSignOut()))
          }, " Sign Out ")
        ])
      ])
    ]),
    _hoisted_7,
    (_ctx.authStore && _ctx.authStore.email)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", null, _toDisplayString(_ctx.authStore.email), 1),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sendResetEmail())),
            href: ".",
            class: "button-link"
          }, " Reset Password "),
          _createTextVNode(" " + _toDisplayString(_ctx.resetText), 1)
        ]))
      : _createCommentVNode("", true),
    _hoisted_10
  ]))
}